/**
 * Auto-generated Locale Data File for fr-FR.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 21,
    bcp47Tag: 'fr-FR',
    name: 'French',
    localizedName: 'Français',
    localizedNameList: [
        {
            id: 18,
            name: 'allemand',
        },
        {
            id: 4,
            name: 'anglais',
        },
        {
            id: 67,
            name: 'anglais australien',
        },
        {
            id: 59,
            name: 'anglais britannique',
        },
        {
            id: 66,
            name: 'anglais canadien',
        },
        {
            id: 70,
            name: 'bengali',
        },
        {
            id: 6,
            name: 'chinois simplifié',
        },
        {
            id: 63,
            name: 'chinois traditionnel',
        },
        {
            id: 55,
            name: 'coréen',
        },
        {
            id: 68,
            name: 'danois',
        },
        {
            id: 10,
            name: 'espagnol',
        },
        {
            id: 72,
            name: 'espagnol d’Amérique latine',
        },
        {
            id: 61,
            name: 'finnois',
        },
        {
            id: 21,
            name: 'français',
        },
        {
            id: 65,
            name: 'français canadien',
        },
        {
            id: 71,
            name: 'hindi',
        },
        {
            id: 16,
            name: 'italien',
        },
        {
            id: 19,
            name: 'japonais',
        },
        {
            id: 24,
            name: 'néerlandais',
        },
        {
            id: 69,
            name: 'norvégien bokmål',
        },
        {
            id: 30,
            name: 'polonais',
        },
        {
            id: 14,
            name: 'portugais',
        },
        {
            id: 8,
            name: 'russe',
        },
        {
            id: 57,
            name: 'suédois',
        },
        {
            id: 49,
            name: 'turc',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# mille} one {# millier}}',
        },
        {
            digits: 2,
            msg: '{count, number} mille',
        },
        {
            digits: 3,
            msg: '{count, number} mille',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# millions} one {# million}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# millions} one {# million}}',
        },
        {
            digits: 3,
            msg: '{count, plural, other {# millions} one {# million}}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# milliards} one {# milliard}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# milliards} one {# milliard}}',
        },
        {
            digits: 3,
            msg: '{count, plural, other {# milliards} one {# milliard}}',
        },
        {
            digits: 1,
            msg: '{count, plural, other {# billions} one {# billion}}',
        },
        {
            digits: 2,
            msg: '{count, plural, other {# billions} one {# billion}}',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number} k',
        },
        {
            digits: 2,
            msg: '{count, number} k',
        },
        {
            digits: 3,
            msg: '{count, number} k',
        },
        {
            digits: 1,
            msg: '{count, number} M',
        },
        {
            digits: 2,
            msg: '{count, number} M',
        },
        {
            digits: 3,
            msg: '{count, number} M',
        },
        {
            digits: 1,
            msg: '{count, number} Md',
        },
        {
            digits: 2,
            msg: '{count, number} Md',
        },
        {
            digits: 3,
            msg: '{count, number} Md',
        },
        {
            digits: 1,
            msg: '{count, number} Bn',
        },
        {
            digits: 2,
            msg: '{count, number} Bn',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 Kiritimati +14',
        nameLocalized: 'Kiritimati',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 Apia +13/+14',
        nameLocalized: 'Apia',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 Fakaofo +13',
        nameLocalized: 'Fakaofo',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 Tongatapu +13/+14',
        nameLocalized: 'Tongatapu',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 Chatham +1245/+1345',
        nameLocalized: 'Chatham',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 Anadyr +12',
        nameLocalized: 'Anadyr',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 Auckland NZST',
        nameLocalized: 'Auckland',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 Fidji +12/+13',
        nameLocalized: 'Fidji',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 Funafuti +12',
        nameLocalized: 'Funafuti',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 Kamtchatka +12',
        nameLocalized: 'Kamtchatka',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 Majuro +12',
        nameLocalized: 'Majuro',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 McMurdo NZST',
        nameLocalized: 'McMurdo',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 Nauru +12',
        nameLocalized: 'Nauru',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 Tarawa +12',
        nameLocalized: 'Tarawa',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 Wake +12',
        nameLocalized: 'Wake',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 Wallis +12',
        nameLocalized: 'Wallis',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 Éfaté +11/+12',
        nameLocalized: 'Éfaté',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 Guadalcanal +11',
        nameLocalized: 'Guadalcanal',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 Kosrae +11',
        nameLocalized: 'Kosrae',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 Magadan +11',
        nameLocalized: 'Magadan',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 Norfolk +11/+12',
        nameLocalized: 'Norfolk',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 Nouméa +11/+12',
        nameLocalized: 'Nouméa',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 Pohnpei +11',
        nameLocalized: 'Pohnpei',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 Sakhaline +11',
        nameLocalized: 'Sakhaline',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 Lord Howe +1030/+11',
        nameLocalized: 'Lord Howe',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 Brisbane AEST',
        nameLocalized: 'Brisbane',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 Chuuk +10',
        nameLocalized: 'Chuuk',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 Dumont-d’Urville +10',
        nameLocalized: 'Dumont-d’Urville',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 Guam ChST',
        nameLocalized: 'Guam',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 Hobart AEST',
        nameLocalized: 'Hobart',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 Lindeman AEST',
        nameLocalized: 'Lindeman',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 Melbourne AEST',
        nameLocalized: 'Melbourne',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 Port Moresby +10',
        nameLocalized: 'Port Moresby',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 Saipan ChST',
        nameLocalized: 'Saipan',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 Sydney AEST',
        nameLocalized: 'Sydney',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 Vladivostok +10',
        nameLocalized: 'Vladivostok',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 Adélaïde ACST',
        nameLocalized: 'Adélaïde',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 Broken Hill ACST',
        nameLocalized: 'Broken Hill',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 Darwin ACST',
        nameLocalized: 'Darwin',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 Dili +09',
        nameLocalized: 'Dili',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 Iakoutsk +09',
        nameLocalized: 'Iakoutsk',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 Jayapura WIT',
        nameLocalized: 'Jayapura',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 Palaos +09',
        nameLocalized: 'Palaos',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 Pyongyang KST',
        nameLocalized: 'Pyongyang',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 Séoul KST',
        nameLocalized: 'Séoul',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 Tokyo JST',
        nameLocalized: 'Tokyo',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 Eucla +0845/+0945',
        nameLocalized: 'Eucla',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 Brunei +08',
        nameLocalized: 'Brunei',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 Casey +08',
        nameLocalized: 'Casey',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 Hong Kong HKST',
        nameLocalized: 'Hong Kong',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 Irkoutsk +08',
        nameLocalized: 'Irkoutsk',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 Kuala Lumpur +08',
        nameLocalized: 'Kuala Lumpur',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 Kuching +08',
        nameLocalized: 'Kuching',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 Macao CST',
        nameLocalized: 'Macao',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 Macassar WITA',
        nameLocalized: 'Macassar',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 Manille PST',
        nameLocalized: 'Manille',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 Oulan-Bator +08/+09',
        nameLocalized: 'Oulan-Bator',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 Perth AWST',
        nameLocalized: 'Perth',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 Shanghai CST',
        nameLocalized: 'Shanghai',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 Singapour +08',
        nameLocalized: 'Singapour',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 Taipei CST',
        nameLocalized: 'Taipei',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 Tchoïbalsan +08/+09',
        nameLocalized: 'Tchoïbalsan',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 Bangkok +07',
        nameLocalized: 'Bangkok',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 Christmas +07',
        nameLocalized: 'Christmas',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 Davis +07',
        nameLocalized: 'Davis',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 Hô-Chi-Minh-Ville +07',
        nameLocalized: 'Hô-Chi-Minh-Ville',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 Hovd +07/+08',
        nameLocalized: 'Hovd',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 Jakarta WIB',
        nameLocalized: 'Jakarta',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 Krasnoïarsk +07',
        nameLocalized: 'Krasnoïarsk',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 Novossibirsk +07',
        nameLocalized: 'Novossibirsk',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 Phnom Penh +07',
        nameLocalized: 'Phnom Penh',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 Pontianak WIB',
        nameLocalized: 'Pontianak',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 Vientiane +07',
        nameLocalized: 'Vientiane',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 Cocos +0630',
        nameLocalized: 'Cocos',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 Bichkek +06',
        nameLocalized: 'Bichkek',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 Chagos +06',
        nameLocalized: 'Chagos',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 Dhaka +06/+07',
        nameLocalized: 'Dhaka',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 Omsk +06',
        nameLocalized: 'Omsk',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 Thimphu +06',
        nameLocalized: 'Thimphu',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 Ürümqi +06',
        nameLocalized: 'Ürümqi',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 Colombo +0530',
        nameLocalized: 'Colombo',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 Achgabat +05',
        nameLocalized: 'Achgabat',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 Aktaou +05',
        nameLocalized: 'Aktaou',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 Aktioubinsk +05',
        nameLocalized: 'Aktioubinsk',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 Alma Ata +05',
        nameLocalized: 'Alma Ata',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 Douchanbé +05',
        nameLocalized: 'Douchanbé',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 Ekaterinbourg +05',
        nameLocalized: 'Ekaterinbourg',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 Karachi PKST',
        nameLocalized: 'Karachi',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 Kerguelen +05',
        nameLocalized: 'Kerguelen',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 Kzyl Orda +05',
        nameLocalized: 'Kzyl Orda',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 Maldives +05',
        nameLocalized: 'Maldives',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 Mawson +05',
        nameLocalized: 'Mawson',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 Ouralsk +05',
        nameLocalized: 'Ouralsk',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 Samarcande +05',
        nameLocalized: 'Samarcande',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 Tachkent +05',
        nameLocalized: 'Tachkent',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 Vostok +05',
        nameLocalized: 'Vostok',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 Kaboul +0430',
        nameLocalized: 'Kaboul',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 Bakou +04/+05',
        nameLocalized: 'Bakou',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 Dubaï +04',
        nameLocalized: 'Dubaï',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 Erevan +04/+05',
        nameLocalized: 'Erevan',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 La Réunion +04',
        nameLocalized: 'La Réunion',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 Mahé +04',
        nameLocalized: 'Mahé',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 Mascate +04',
        nameLocalized: 'Mascate',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 Maurice +04/+05',
        nameLocalized: 'Maurice',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 Samara +04',
        nameLocalized: 'Samara',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 Tbilissi +04',
        nameLocalized: 'Tbilissi',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 Téhéran +0330/+0430',
        nameLocalized: 'Téhéran',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 Addis-Abeba EAT',
        nameLocalized: 'Addis-Abeba',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 Aden +03',
        nameLocalized: 'Aden',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 Amman +03',
        nameLocalized: 'Amman',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 Antananarivo EAT',
        nameLocalized: 'Antananarivo',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 Bagdad +03/+04',
        nameLocalized: 'Bagdad',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 Bahreïn +03',
        nameLocalized: 'Bahreïn',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 Comores EAT',
        nameLocalized: 'Comores',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 Damas +03',
        nameLocalized: 'Damas',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 Dar es Salaam EAT',
        nameLocalized: 'Dar es Salaam',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 Djibouti EAT',
        nameLocalized: 'Djibouti',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 Kampala EAT',
        nameLocalized: 'Kampala',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 Koweït +03',
        nameLocalized: 'Koweït',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 Mayotte EAT',
        nameLocalized: 'Mayotte',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 Minsk +03',
        nameLocalized: 'Minsk',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 Mogadiscio EAT',
        nameLocalized: 'Mogadiscio',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 Moscou MSK',
        nameLocalized: 'Moscou',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 Nairobi EAT',
        nameLocalized: 'Nairobi',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 Qatar +03',
        nameLocalized: 'Qatar',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 Riyad +03',
        nameLocalized: 'Riyad',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 Showa +03',
        nameLocalized: 'Showa',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 Simferopol MSK',
        nameLocalized: 'Simferopol',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 Volgograd MSK',
        nameLocalized: 'Volgograd',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 Athènes EET',
        nameLocalized: 'Athènes',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 Beyrouth EET',
        nameLocalized: 'Beyrouth',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 Blantyre CAT',
        nameLocalized: 'Blantyre',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 Bucarest EET',
        nameLocalized: 'Bucarest',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 Bujumbura CAT',
        nameLocalized: 'Bujumbura',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 Chisinau EET',
        nameLocalized: 'Chisinau',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 Gaborone CAT',
        nameLocalized: 'Gaborone',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 Gaza EET',
        nameLocalized: 'Gaza',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 Harare CAT',
        nameLocalized: 'Harare',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 Helsinki EET',
        nameLocalized: 'Helsinki',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 Jérusalem IST',
        nameLocalized: 'Jérusalem',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 Johannesburg SAST',
        nameLocalized: 'Johannesburg',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 Kaliningrad EET',
        nameLocalized: 'Kaliningrad',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 Khartoum CAT',
        nameLocalized: 'Khartoum',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 Kiev EET',
        nameLocalized: 'Kiev',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 Kigali CAT',
        nameLocalized: 'Kigali',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 Le Caire EET',
        nameLocalized: 'Le Caire',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 Lubumbashi CAT',
        nameLocalized: 'Lubumbashi',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 Lusaka CAT',
        nameLocalized: 'Lusaka',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 Maputo CAT',
        nameLocalized: 'Maputo',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 Mariehamn EET',
        nameLocalized: 'Mariehamn',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 Maseru SAST',
        nameLocalized: 'Maseru',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 Mbabane SAST',
        nameLocalized: 'Mbabane',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 Nicosie EET',
        nameLocalized: 'Nicosie',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 Riga EET',
        nameLocalized: 'Riga',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 Sofia EET',
        nameLocalized: 'Sofia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 Tallinn EET',
        nameLocalized: 'Tallinn',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 Tripoli (Libye) EET',
        nameLocalized: 'Tripoli (Libye)',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 Vilnius EET',
        nameLocalized: 'Vilnius',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 Windhoek WAT',
        nameLocalized: 'Windhoek',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 Alger CET',
        nameLocalized: 'Alger',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 Amsterdam CET',
        nameLocalized: 'Amsterdam',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 Andorre CET',
        nameLocalized: 'Andorre',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 Bangui WAT',
        nameLocalized: 'Bangui',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 Belgrade CET',
        nameLocalized: 'Belgrade',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 Berlin CET',
        nameLocalized: 'Berlin',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 Bratislava CET',
        nameLocalized: 'Bratislava',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 Brazzaville WAT',
        nameLocalized: 'Brazzaville',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 Bruxelles CET',
        nameLocalized: 'Bruxelles',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 Budapest CET',
        nameLocalized: 'Budapest',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 Casablanca +01/+00',
        nameLocalized: 'Casablanca',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 Ceuta CET',
        nameLocalized: 'Ceuta',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 Copenhague CET',
        nameLocalized: 'Copenhague',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 Douala WAT',
        nameLocalized: 'Douala',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 Gibraltar CET',
        nameLocalized: 'Gibraltar',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 heure d’été irlandaise IST/GMT',
        nameLocalized: 'heure d’été irlandaise',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 Kinshasa WAT',
        nameLocalized: 'Kinshasa',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 Laâyoune +01/+00',
        nameLocalized: 'Laâyoune',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 Lagos WAT',
        nameLocalized: 'Lagos',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 Le Vatican CET',
        nameLocalized: 'Le Vatican',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 Libreville WAT',
        nameLocalized: 'Libreville',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 Ljubljana CET',
        nameLocalized: 'Ljubljana',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 Longyearbyen CET',
        nameLocalized: 'Longyearbyen',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 Luanda WAT',
        nameLocalized: 'Luanda',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 Luxembourg CET',
        nameLocalized: 'Luxembourg',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 Madrid CET',
        nameLocalized: 'Madrid',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 Malabo WAT',
        nameLocalized: 'Malabo',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 Malte CET',
        nameLocalized: 'Malte',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 Monaco CET',
        nameLocalized: 'Monaco',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 N’Djamena WAT',
        nameLocalized: 'N’Djamena',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 Niamey WAT',
        nameLocalized: 'Niamey',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 Oslo CET',
        nameLocalized: 'Oslo',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 Paris CET',
        nameLocalized: 'Paris',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 Podgorica CET',
        nameLocalized: 'Podgorica',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 Porto-Novo WAT',
        nameLocalized: 'Porto-Novo',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 Prague CET',
        nameLocalized: 'Prague',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 Rome CET',
        nameLocalized: 'Rome',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 Saint-Marin CET',
        nameLocalized: 'Saint-Marin',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 Sarajevo CET',
        nameLocalized: 'Sarajevo',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 Skopje CET',
        nameLocalized: 'Skopje',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 Stockholm CET',
        nameLocalized: 'Stockholm',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 Tirana CET',
        nameLocalized: 'Tirana',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 Tunis CEST',
        nameLocalized: 'Tunis',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 Vaduz CET',
        nameLocalized: 'Vaduz',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 Varsovie CET',
        nameLocalized: 'Varsovie',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 Vienne CET',
        nameLocalized: 'Vienne',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 Zagreb CET',
        nameLocalized: 'Zagreb',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 Zurich CET',
        nameLocalized: 'Zurich',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 Abidjan GMT',
        nameLocalized: 'Abidjan',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 Accra GMT',
        nameLocalized: 'Accra',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 Bamako GMT',
        nameLocalized: 'Bamako',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 Banjul GMT',
        nameLocalized: 'Banjul',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 Bissau GMT',
        nameLocalized: 'Bissau',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 Calcutta UTC',
        nameLocalized: 'Calcutta',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 Conakry GMT',
        nameLocalized: 'Conakry',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 Dakar GMT',
        nameLocalized: 'Dakar',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 Danmarkshavn GMT',
        nameLocalized: 'Danmarkshavn',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 Enderbury -00',
        nameLocalized: 'Enderbury',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 Freetown GMT',
        nameLocalized: 'Freetown',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 Guernesey GMT/BST',
        nameLocalized: 'Guernesey',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 Île de Man GMT/BST',
        nameLocalized: 'Île de Man',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 Îles Canaries WET',
        nameLocalized: 'Îles Canaries',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 Îles Féroé UTC',
        nameLocalized: 'Îles Féroé',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 Jersey GMT/BST',
        nameLocalized: 'Jersey',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 Katmandou UTC',
        nameLocalized: 'Katmandou',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 Lisbonne WET',
        nameLocalized: 'Lisbonne',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 Lomé GMT',
        nameLocalized: 'Lomé',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 Londres GMT/BST',
        nameLocalized: 'Londres',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 Madère WET',
        nameLocalized: 'Madère',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 Monrovia GMT',
        nameLocalized: 'Monrovia',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 Nouakchott GMT',
        nameLocalized: 'Nouakchott',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 Ouagadougou GMT',
        nameLocalized: 'Ouagadougou',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 Rangoun UTC',
        nameLocalized: 'Rangoun',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 Reykjavik GMT',
        nameLocalized: 'Reykjavik',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 Sainte-Hélène GMT',
        nameLocalized: 'Sainte-Hélène',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 São Tomé GMT',
        nameLocalized: 'São Tomé',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 Açores -01/+00',
        nameLocalized: 'Açores',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 Cap-Vert -01',
        nameLocalized: 'Cap-Vert',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 Géorgie du Sud -02',
        nameLocalized: 'Géorgie du Sud',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 Ittoqqortoormiit -02/-01',
        nameLocalized: 'Ittoqqortoormiit',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 Noronha -02',
        nameLocalized: 'Noronha',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 Saint-Jean de Terre-Neuve NST',
        nameLocalized: 'Saint-Jean de Terre-Neuve',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 Araguaína -03',
        nameLocalized: 'Araguaína',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 Bahia -03',
        nameLocalized: 'Bahia',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 Belém -03',
        nameLocalized: 'Belém',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 Cayenne -03',
        nameLocalized: 'Cayenne',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 Córdoba -03/-02',
        nameLocalized: 'Córdoba',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 Fortaleza -03',
        nameLocalized: 'Fortaleza',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 La Rioja -03',
        nameLocalized: 'La Rioja',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 Maceió -03',
        nameLocalized: 'Maceió',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 Miquelon -03/-02',
        nameLocalized: 'Miquelon',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 Montevideo -03/-02',
        nameLocalized: 'Montevideo',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 Nuuk -03/-02',
        nameLocalized: 'Nuuk',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 Palmer -03',
        nameLocalized: 'Palmer',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 Paramaribo -03',
        nameLocalized: 'Paramaribo',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 Recife -03',
        nameLocalized: 'Recife',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 Río Gallegos -03',
        nameLocalized: 'Río Gallegos',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 Rothera -03',
        nameLocalized: 'Rothera',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 San Juan -03',
        nameLocalized: 'San Juan',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 São Paulo -03/-02',
        nameLocalized: 'São Paulo',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 Stanley -03',
        nameLocalized: 'Stanley',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 Tucumán -03/-02',
        nameLocalized: 'Tucumán',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 Ushuaïa -03',
        nameLocalized: 'Ushuaïa',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 Anguilla AST',
        nameLocalized: 'Anguilla',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 Antigua AST',
        nameLocalized: 'Antigua',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 Aruba AST',
        nameLocalized: 'Aruba',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 Asunción -04/-03',
        nameLocalized: 'Asunción',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 Bermudes AST',
        nameLocalized: 'Bermudes',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 Blanc-Sablon AST',
        nameLocalized: 'Blanc-Sablon',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 Boa Vista -04',
        nameLocalized: 'Boa Vista',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 Campo Grande -04/-03',
        nameLocalized: 'Campo Grande',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 Caracas -04',
        nameLocalized: 'Caracas',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 Cuiabá -04/-03',
        nameLocalized: 'Cuiabá',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 Curaçao AST',
        nameLocalized: 'Curaçao',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 Dominique AST',
        nameLocalized: 'Dominique',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 Glace Bay AST',
        nameLocalized: 'Glace Bay',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 Goose Bay AST',
        nameLocalized: 'Goose Bay',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 Grenade AST',
        nameLocalized: 'Grenade',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 Guadeloupe AST',
        nameLocalized: 'Guadeloupe',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 Guyana -04',
        nameLocalized: 'Guyana',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 Halifax AST',
        nameLocalized: 'Halifax',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 La Barbade AST',
        nameLocalized: 'La Barbade',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 La Paz -04',
        nameLocalized: 'La Paz',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 Manaos -04',
        nameLocalized: 'Manaos',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 Martinique AST',
        nameLocalized: 'Martinique',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 Moncton AST',
        nameLocalized: 'Moncton',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 Montserrat AST',
        nameLocalized: 'Montserrat',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 Port-d’Espagne AST',
        nameLocalized: 'Port-d’Espagne',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 Porto Rico AST',
        nameLocalized: 'Porto Rico',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 Porto Velho -04',
        nameLocalized: 'Porto Velho',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 Saint-Christophe AST',
        nameLocalized: 'Saint-Christophe',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 Saint-Domingue AST',
        nameLocalized: 'Saint-Domingue',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 Saint-Thomas AST',
        nameLocalized: 'Saint-Thomas',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 Saint-Vincent AST',
        nameLocalized: 'Saint-Vincent',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 Sainte-Lucie AST',
        nameLocalized: 'Sainte-Lucie',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 Santiago -04/-03',
        nameLocalized: 'Santiago',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 Thulé AST',
        nameLocalized: 'Thulé',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 Tortola AST',
        nameLocalized: 'Tortola',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 Bogota -05/-04',
        nameLocalized: 'Bogota',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 Caïmans EST',
        nameLocalized: 'Caïmans',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 Cancún EST',
        nameLocalized: 'Cancún',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 Détroit EST',
        nameLocalized: 'Détroit',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 Eirunepé -05',
        nameLocalized: 'Eirunepé',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 Grand Turk EST',
        nameLocalized: 'Grand Turk',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 Guayaquil -05/-04',
        nameLocalized: 'Guayaquil',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 Iqaluit EST',
        nameLocalized: 'Iqaluit',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 Jamaïque EST',
        nameLocalized: 'Jamaïque',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 La Havane CST',
        nameLocalized: 'La Havane',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 Lima -05/-04',
        nameLocalized: 'Lima',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 Marengo [Indiana] EST',
        nameLocalized: 'Marengo [Indiana]',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 Monticello [Kentucky] EST',
        nameLocalized: 'Monticello [Kentucky]',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 Nassau EST',
        nameLocalized: 'Nassau',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 New York EST',
        nameLocalized: 'New York',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 Panama EST',
        nameLocalized: 'Panama',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 Petersburg [Indiana] EST',
        nameLocalized: 'Petersburg [Indiana]',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 Port-au-Prince EST',
        nameLocalized: 'Port-au-Prince',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 Rio Branco -05',
        nameLocalized: 'Rio Branco',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 Toronto EST',
        nameLocalized: 'Toronto',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 Vevay [Indiana] EST',
        nameLocalized: 'Vevay [Indiana]',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 Vincennes [Indiana] EST',
        nameLocalized: 'Vincennes [Indiana]',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 Winamac [Indiana] EST',
        nameLocalized: 'Winamac [Indiana]',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 Belize CST',
        nameLocalized: 'Belize',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 Center (Dakota du Nord) CST',
        nameLocalized: 'Center (Dakota du Nord)',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 Chicago CST',
        nameLocalized: 'Chicago',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 Chihuahua CST',
        nameLocalized: 'Chihuahua',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 Costa Rica CST',
        nameLocalized: 'Costa Rica',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 El Salvador CST',
        nameLocalized: 'El Salvador',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 Galápagos -06/-05',
        nameLocalized: 'Galápagos',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 Guatemala CST',
        nameLocalized: 'Guatemala',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 Île de Pâques -06/-05',
        nameLocalized: 'Île de Pâques',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 Knox [Indiana] CST',
        nameLocalized: 'Knox [Indiana]',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 Managua CST',
        nameLocalized: 'Managua',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 Menominee CST',
        nameLocalized: 'Menominee',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 Mérida CST',
        nameLocalized: 'Mérida',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 Mexico CST',
        nameLocalized: 'Mexico',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 Monterrey CST',
        nameLocalized: 'Monterrey',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 New Salem (Dakota du Nord) CST',
        nameLocalized: 'New Salem (Dakota du Nord)',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 Rankin Inlet CST',
        nameLocalized: 'Rankin Inlet',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 Regina CST',
        nameLocalized: 'Regina',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 Resolute CST',
        nameLocalized: 'Resolute',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 Swift Current CST',
        nameLocalized: 'Swift Current',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 Tegucigalpa CST',
        nameLocalized: 'Tegucigalpa',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 Winnipeg CST',
        nameLocalized: 'Winnipeg',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 Boise MST',
        nameLocalized: 'Boise',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 Cambridge Bay MST',
        nameLocalized: 'Cambridge Bay',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 Dawson MST',
        nameLocalized: 'Dawson',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 Dawson Creek MST',
        nameLocalized: 'Dawson Creek',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 Denver MST',
        nameLocalized: 'Denver',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 Edmonton MST',
        nameLocalized: 'Edmonton',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 Hermosillo MST',
        nameLocalized: 'Hermosillo',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 Inuvik MST',
        nameLocalized: 'Inuvik',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 Mazatlán MST',
        nameLocalized: 'Mazatlán',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 Phoenix MST',
        nameLocalized: 'Phoenix',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 Whitehorse MST',
        nameLocalized: 'Whitehorse',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 Los Angeles PST',
        nameLocalized: 'Los Angeles',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 Pitcairn -08',
        nameLocalized: 'Pitcairn',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 Tijuana PST',
        nameLocalized: 'Tijuana',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 Vancouver PST',
        nameLocalized: 'Vancouver',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 Marquises -0930',
        nameLocalized: 'Marquises',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 Anchorage AKST',
        nameLocalized: 'Anchorage',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 Gambier -09',
        nameLocalized: 'Gambier',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 Juneau AKST',
        nameLocalized: 'Juneau',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 Nome AKST',
        nameLocalized: 'Nome',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 Yakutat AKST',
        nameLocalized: 'Yakutat',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 Adak HST',
        nameLocalized: 'Adak',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 Honolulu HST',
        nameLocalized: 'Honolulu',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 Rarotonga -10/-0930',
        nameLocalized: 'Rarotonga',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 Tahiti -10',
        nameLocalized: 'Tahiti',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 Midway SST',
        nameLocalized: 'Midway',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 Niue -11',
        nameLocalized: 'Niue',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 Pago Pago SST',
        nameLocalized: 'Pago Pago',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 1,
    weekendStart: 6,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: 'dim.',
            mon: 'lun.',
            tue: 'mar.',
            wed: 'mer.',
            thu: 'jeu.',
            fri: 'ven.',
            sat: 'sam.',
        },
        narrow: {
            sun: 'D',
            mon: 'L',
            tue: 'M',
            wed: 'M',
            thu: 'J',
            fri: 'V',
            sat: 'S',
        },
        short: {
            sun: 'di',
            mon: 'lu',
            tue: 'ma',
            wed: 'me',
            thu: 'je',
            fri: 've',
            sat: 'sa',
        },
        wide: {
            sun: 'dimanche',
            mon: 'lundi',
            tue: 'mardi',
            wed: 'mercredi',
            thu: 'jeudi',
            fri: 'vendredi',
            sat: 'samedi',
        },
    },
    standAlone: {
        abbreviated: {
            sun: 'dim.',
            mon: 'lun.',
            tue: 'mar.',
            wed: 'mer.',
            thu: 'jeu.',
            fri: 'ven.',
            sat: 'sam.',
        },
        narrow: {
            sun: 'D',
            mon: 'L',
            tue: 'M',
            wed: 'M',
            thu: 'J',
            fri: 'V',
            sat: 'S',
        },
        short: {
            sun: 'di',
            mon: 'lu',
            tue: 'ma',
            wed: 'me',
            thu: 'je',
            fri: 've',
            sat: 'sa',
        },
        wide: {
            sun: 'dimanche',
            mon: 'lundi',
            tue: 'mardi',
            wed: 'mercredi',
            thu: 'jeudi',
            fri: 'vendredi',
            sat: 'samedi',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
